<div class="" [hidden]="!isLoaded">

  <mat-toolbar class="no-background">
    <span>【管理者用】ダッシュボード</span>
    <span class="spacer"></span>
    <a mat-button class="add-link" routerLink="/admin/search/user">
      <mat-icon>info</mat-icon>出資者情報
    </a>

    <a mat-button class="add-link" routerLink="/admin/weeklyReport">
      <mat-icon>paid</mat-icon>週報
    </a>

    <a mat-button class="add-link" routerLink="/admin/monthlyReport">
      <mat-icon>calendar_month</mat-icon>月報
    </a>

  </mat-toolbar>


  <div class="card-grid" *ngIf="stats">

    @for (cat of categories; track cat;) {
      <div class="dashboard-card" (click)="link('/admin/inquiry', cat.label)">
        <div class="card-header">
          <span class="card-title">{{cat.label}}</span>
        </div>
        <div class="card-body">
          <div *ngFor="let status of getStatusList(stats, cat.key, getStatusMap(cat.label))" class="status-row">
            <span class="status-label">
              {{ status.label }} : {{ status.total }}
            </span>
            <span class="priority-breakdown">
              ({{ getPriorityBreakdownText(status) }})
            </span>
          </div>
        </div>
      </div>
    }

    <!--
    <div class="dashboard-card" (click)="link('/admin/withdrawal')">
      <div class="card-header">
        <span class="card-title">出金依頼</span>
      </div>
      <div class="card-body">
        <div *ngFor="let status of getStatusList(stats.withdrawals, ['受付', '確認中', '対応中', '出金額確定', '出金済'])" class="status-row">
          <span class="status-label">
            {{ status.label }} : {{ status.total }}
          </span>
          <span class="priority-breakdown">
            ({{ getPriorityBreakdownText(status) }})
          </span>
        </div>
      </div>
    </div>
    -->

  </div>

  <div *ngIf="stats" style="margin-top: 16px;" class="dashboard-card" (click)="link('/admin/withdrawalTransaction', undefined)">
    <div class="card-header">
      <span class="card-title">送金処理管理</span>
    </div>
    <div class="card-body">
      <table style="font-size: 13px;">
        <thead>
          <tr>
            <th style="width: 110px;">出金額確定月</th>
            <th style="width: 40px;">通貨</th>
            <th style="width: 60px;">総件数</th>
            <th style="width: 60px;">処理済</th>
            <th style="width: 60px;">未完了</th>
            <th style="width: 100px;">出金確定総額</th>
            <th style="width: 100px;">送金済額</th>
            <th style="width: 100px;">未送金額</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of stats.transactions">
            <td>{{row.month}}</td>
            <td>{{row.currency}}</td>
            <td class="numeric">{{row.count}}</td>
            <td class="numeric">{{row.complete_count}}</td>
            <td class="numeric">{{row.incomplete_count}}</td>
            <td class="numeric">{{formatAmount(row.total_requested_amount, row.currency)}}</td>
            <td class="numeric">{{formatAmount(row.total_withdrawn_amount, row.currency)}}</td>
            <td class="numeric">{{formatAmount(row.total_unpaid_amount, row.currency)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

